package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_02_23_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just arrived at Dunstone, which is surrounded by a newly built palisade wall caked with the bodies of goblins and giant-kin. The heroes learn about the recent attacks on the town which have been coming from the South and East in the general direction of Cark.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes enter the local inn, the Lizardly Lady. Dirk hits on a mysterious beauty named Dolly Mott. To the surprise of the heroes, Dolly has a pin with familiar looking violet colored gem — the “compound eye.” Dirk intends to seduce Dolly in order to obtain the gem, but he falls back on intimidation as a strategy and fails. Dolly magically commands Dirk to flee. The heroes chase and corner the petite, evil woman but are conflicted about next steps. Caper calms her and Bigglesworth takes her hand and leads her back to her room, where Caper, Tuesday, Annette, and Bigglesworth attempt to persuade her to give or loan them the gem.  Falorn is in the heroes’ room, and Dirk is downstairs.")
    }
}
